
import React, {useMemo} from "react"
import {useSiren} from "./SirenContext";
import {Layout} from "./Layout";
import {ImportHistory} from "./subpages/ImportHistory";
import {NewImport} from "./subpages/NewImport";
import {ImportManagementProvider} from "./ImportManagementContext";
import { AlertLog } from "./subpages/AlertLog";
import {AlertCreate} from "./subpages/AlertCreate";
import {HotlineNumberList} from "./subpages/HotlineNumberList";
import {HotlineNumberCreate} from "./subpages/HotlineNumberCreate";
import {HotlineList} from "./subpages/HotlineList";
import {HotlineCreate} from "./subpages/HotlineCreate";



export function Hotlines() {

    const {subMenuCurrent, clientID} = useSiren()

    const page = useMemo(() => {
        switch (subMenuCurrent) {
            case "hotlines":
                return <HotlineList/>
            case "numbers":
                return <HotlineNumberList/>
            case "create_number":
                return <HotlineNumberCreate/>
            case "create_hotline":
                return <HotlineCreate/>
        }

        return null
    }, [subMenuCurrent])

    return (
        <Layout menuCurrent={"hotline"}>
            {page}
        </Layout>
    )


}